export default __webpack_public_path__ + "static/media/extension_giftcard_silver_w1.6dc2db10.svg";